import { Button } from "@/shared/ui/button.tsx";
import { Minus, Plus, Redo2, Undo2 } from "lucide-react";
import { useMaskEditorContext } from "react-canvas-masker";
import ChatInput from "../ChatInput";

type Props = {
  input: string,
  setInput: (val: string) => void,
  handleSend: () => void,
  onImageUndo: () => void,
  canUndo: boolean
}

const MaskEditorControls = ({ handleSend, setInput, input, canUndo, onImageUndo }: Props) => {
  const { undo, redo, scale, zoomIn, zoomOut, historyIndex  } =
    useMaskEditorContext();

  return (
    <>
      <div className="absolute z-50 bottom-2 left-[50%] -translate-x-[50%] w-3/4 sm:w-1/2">
        <ChatInput input={input} setInput={setInput} handleSend={handleSend} />
      </div>
      <div className="absolute top-2 right-4 flex items-center gap-2 z-50">
        <Button 
          onClick={zoomOut}
          size="icon" className="bg-indigo-600 rounded-full">
          <Minus size={16} />
        </Button>
        <p className="h-10 bg-white rounded-md flex items-center border border-indigo-600 justify-center px-2 text-sm font-poppins tracking-wide font-medium">{Math.round(scale * 100)}%</p>
        <Button 
          onClick={zoomIn}
          size="icon" className="bg-indigo-600 rounded-full">
          <Plus size={16} />
        </Button>
      </div>
      <div className="absolute bottom-2 left-4 flex items-center gap-2 z-50">
        <Button 
          onClick={() => {
            console.log(historyIndex)
            if(( historyIndex === -1 || historyIndex === 0 ) && canUndo){
              onImageUndo()
            } else {
              undo()
            }
          }}
          size="icon" className="bg-indigo-600 rounded-full">
          <Undo2 size={16} />
        </Button>
        <Button 
          onClick={redo}
          size="icon" className="bg-indigo-600 rounded-full">
          <Redo2 size={16} />
        </Button>
      </div>
    </>
  );
};

export default MaskEditorControls;
